























import { Component, Vue, Prop } from 'vue-property-decorator';
import 'highlight.js/styles/monokai-sublime.css';
import hljs from 'highlight.js/lib/common';

@Component({
  i18n: {
    messages: {
      en: {
        jsonSummary: "JSON",
        copy: "Copy",
        copiedToClipboard: "Copied to clipboard",
      },
      nb: {
        jsonSummary: "JSON",
        copy: "Kopier",
        copiedToClipboard: "Kopiert til utklippstavle",
      },
    },
  },
})
export default class JsonPolisher extends Vue {
  @Prop({ type: Boolean, default: true }) private open!: boolean;
  @Prop({ type: [ String, Object ], required: true }) private content!: string | object;

  /**
   * Pretty JSON formatter
   */
  private get formattedContent(): string {
    if (typeof this.content === 'string') {
      try {
        return JSON.stringify(JSON.parse(this.content), null, 2);
      } catch {
        return this.content;
      }
    }

    return JSON.stringify(this.content, null, 2);
  }

  private get highlightedContent(): string {
    const highlighting = hljs.highlight(this.formattedContent, { language: 'json' });
    return highlighting.value;
  }

  private copyToClipboard(): void {
    navigator.clipboard
      .writeText(this.formattedContent)
      .then(() => this.$sMessage.success(this.$t('copiedToClipboard')));
  }
}
